import { useEffect } from "react";

const safeAssign = (target, property, value) => {
  if (target && typeof target.style !== "undefined") {
    target.style[property] = value ?? "";
  }
};

const useRestoreScroll = () => {
  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    const { body, documentElement } = document;

    const previous = {
      bodyOverflow: body?.style?.overflow,
      bodyOverflowY: body?.style?.overflowY,
      htmlOverflow: documentElement?.style?.overflow,
      htmlOverflowY: documentElement?.style?.overflowY,
    };

    safeAssign(body, "overflow", "");
    safeAssign(body, "overflowY", "auto");
    safeAssign(documentElement, "overflow", "");
    safeAssign(documentElement, "overflowY", "auto");

    return () => {
      safeAssign(body, "overflow", previous.bodyOverflow);
      safeAssign(body, "overflowY", previous.bodyOverflowY);
      safeAssign(documentElement, "overflow", previous.htmlOverflow);
      safeAssign(documentElement, "overflowY", previous.htmlOverflowY);
    };
  }, []);
};

export default useRestoreScroll;

